<template>
  <div class="pro-bal-ger-arq">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="config">
        <App-Input :data-time="time" class="pro-bal-ger-arq--dep"
        :cpntStatus='campos.dep.status'
        :cpntId='"pro-bal-ger-arq--dep"'
        :class='campos.dep.class'
        :cpntTabIndex='campos.dep.tabIndex'
        :cpntClassDivField='campos.dep.classDivField'
        :cpntNome='campos.dep.nome'
        :cpntValue='campos.dep.value'
        :cpntAutoComplete='campos.dep.autocomplete'
        :cpntMask='campos.dep.mask'
        :cpntOptionInicialNome='campos.dep.optionInicialNome'
        :cpntOptionInicialValue='campos.dep.optionInicialValue'
        :cpntDisabled='campos.dep.disabled'
        :cpntMostrar='campos.dep.mostrar'
        :cpntAutoFocus='campos.dep.autofocus'
        :cpntMensagem='campos.dep.mensagem'
        :cpntMensagemTipo='campos.dep.mensagemTipo'
        :cpntPlaceholder='campos.dep.placeholder'
        :cpntPosicionar='campos.dep.posicionar'
        :cpntOnChange='(value) => { finRegRecDesOnChangeValueReferencia(value, "dep") }'
        ></App-Input>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linhas"
        :cpntSetarValores="proBalGerArqSetarLinhas"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiOrder="{ codigo: 'asc' }"
        :cpntApiField="field"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        ref="tabela">
          <template v-slot:titulo>
            <App-Button :cpntClass="[ 'btn', 'btn-primary', 'btn-sm' ]" @onClick="proBalGerArqOnGerarArquivo">Gerar arquivo</App-Button>
          </template>

          <!-- COLUNA nome -->
          <template v-slot:col_nome="{ linha }">
            <div v-if="cpntConsultar !== false">
              <span v-html="linha.nome"></span>
            </div>
            <App-Button v-else :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" :class="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === false ? 'app-cadastro-link-disabled' : ''" @onClick='() => { proBalGerArqAbrirCadastro("produto", linha.id) }'>
              <span v-html="linha.nome"></span>
            </App-Button>
          </template>

          <!-- COLUNA ULTIMA ALTERAÇÃO -->
          <template v-slot:col_id_uni="{ linha, indexCV }">
            <template v-if="[ '', null, undefined ].indexOf(linha[indexCV]) === -1">
              <span v-html="linha[indexCV]" :title="linha[indexCV] + ' - ' + linha['virtual_' + indexCV + '_desc']"></span>
            </template>
          </template>

          <template v-slot:col_validade="{ linha, indexL }">
            <App-Select :data-time="time" class="pro-bal-ger-arq--validade"
            :cpntStatus='campos.validade.status'
            :cpntId='"pro-bal-ger-arq--validade--" + linha.id'
            :cpntTabIndex='campos.validade.tabIndex'
            :cpntNome='campos.validade.nome'
            :cpntValue='linha.validade'
            :cpntMensagem='linha.validade_mensagem'
            :cpntMensagemTipo='campos.validade.mensagemTipo'
            :cpntDisabled='campos.validade.disabled'
            :cpntMostrar='campos.validade.mostrar'
            :cpntExplica='campos.validade.explica'
            :cpntPlaceholder='campos.validade.placeholder'
            :cpntValueRef='campos.validade.valueRef'
            :cpntRouter='campos.validade.router'
            :cpntMethod='campos.validade.method'
            :cpntField='campos.validade.field'
            :cpntWhere='campos.validade.where'
            :cpntAddButForm='campos.validade.addButForm'
            :cpntKeyMostra='campos.validade.keyMostra'
            :cpntTipoOrder='campos.validade.tipoOrder'
            :cpntOrder='campos.validade.order'
            :cpntOptions='campos.validade.options'
            :cpntKeyValue='campos.validade.keyValue'
            :cpntSearchMinimo='campos.validade.searchMinimo'
            :cpntMask='campos.validade.mask'
            :cpntNewOption='campos.validade.newOption'
            :cpntOptionInicialNome='campos.validade.optionInicialNome'
            :cpntOptionInicialValue='campos.validade.optionInicialValue'
            :cpntOnChange='(value) => { proBalGerArqOnChangeValue(value, indexL, "validade") }'
            :cpntOnBuscarOptions='(callback) => { campos.validade.onBuscarOptions(callback, indexL) }'
            :ref="indexL + '--validade'"
            ></App-Select>
          </template>
        </App-Tabela>
      </div>
    </template>
  </div>
</template>

<style scoped>
  .pro-bal-ger-arq > .config {
    width: 250px;
    margin: 0px auto;
    padding: 30px 20px 20px 20px;
    background: #e9e9e9;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
    .pro-bal-ger-arq > .config > div {
      text-align: center;
    }
  .pro-bal-ger-arq > .tabela {
    margin-top: 20px;
  }
</style>

<style>
.pro-bal-ger-arq > .config > div > label {
  width: 100%;
}
.pro-bal-ger-arq > .config > div,
.pro-bal-ger-arq > .config > div > input,
.pro-bal-ger-arq > .config > div > label {
    text-align: center;
}

.pro-bal-ger-arq > .tabela > table > tbody > tr > td.col_validade {
  width: 165px;
  min-width: 165px;
  max-width: 165px;
}
.pro-bal-ger-arq > .tabela > table > tbody > tr > td.col_validade > div > span > .pro-bal-ger-arq--validade > .select2-container > a {
  text-align: center !important;
}
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntConsultar: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      }
    },
    components: {
      'Produto-Atualizar-Excel': () => import('@/components/produto/gerenciar/Produto-Atualizar-Excel.vue'),
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'RF-Produto-Etiqueta': () => import('@/components/produto/gerenciar/Etiqueta/RF-Produto-Etiqueta.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        route: '/produto/get',
        colunas: [],
        linhas: [],
        field: {},
        fieldVir: [],
        where: {},
        order: {},
        estruturaQueryGet: [ [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order', 'SemPaginacao' ] ],
        campos: {
          dep: {
            status: '',
            class: '',
            nome: 'Departamento',
            value: '01',
            onChange: (value) => {
              // SETA O VALOR RECEBIDO
              this.$set(this.campos.dep, 'value', value)

              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
            } 
          },
          validade: {
            status: '',
            nome: '',
            keyValue: 'id',
            keyMostra: [ 'id' ],
            mostrar: true,
            optionInicialNome: 'Não informar validade',
            options: [ { id: '1' }, { id: '2' }, { id: '3' }, { id: '4' }, { id: '5' }, { id: '6' }, { id: '7' }, { id: '8' }, { id: '9' }, { id: '10' }, { id: '11' }, { id: '12' }, { id: '13' }, { id: '14' }, { id: '15' }, { id: '16' }, { id: '17' }, { id: '18' }, { id: '19' }, { id: '20' }, { id: '21' }, { id: '22' }, { id: '23' }, { id: '24' }, { id: '25' }, { id: '26' }, { id: '27' }, { id: '28' }, { id: '29' }, { id: '30' }, { id: '31' }, { id: '32' }, { id: '33' }, { id: '34' }, { id: '35' }, { id: '36' }, { id: '37' }, { id: '38' }, { id: '39' }, { id: '40' }, { id: '41' }, { id: '42' }, { id: '43' }, { id: '44' }, { id: '45' }, { id: '46' }, { id: '47' }, { id: '48' }, { id: '49' }, { id: '50' }, { id: '51' }, { id: '52' }, { id: '53' }, { id: '54' }, { id: '55' }, { id: '56' }, { id: '57' }, { id: '58' }, { id: '59' }, { id: '60' }, { id: '61' }, { id: '62' }, { id: '63' }, { id: '64' }, { id: '65' }, { id: '66' }, { id: '67' }, { id: '68' }, { id: '69' }, { id: '70' }, { id: '71' }, { id: '72' }, { id: '73' }, { id: '74' }, { id: '75' }, { id: '76' }, { id: '77' }, { id: '78' }, { id: '79' }, { id: '80' }, { id: '81' }, { id: '82' }, { id: '83' }, { id: '84' }, { id: '85' }, { id: '86' }, { id: '87' }, { id: '88' }, { id: '89' }, { id: '90' }, { id: '91' }, { id: '92' }, { id: '93' }, { id: '94' }, { id: '95' }, { id: '96' }, { id: '97' }, { id: '98' }, { id: '99' }, { id: '100' } ],
            value: '',
            valueIni: '',
            disabled: false,
            onBuscarOptions: this.proBalGerArqBuscarTipoPagamento
          }
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.proBalGerArqSetarStatusGeral('carregando')

      // INICIA O CARREGAMENTO
      this.proBalGerArqBuscarLinhas()
    },
    methods: {
      proBalGerArqFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.proBalGerArqBuscarLinhas()
        }
      },
      proBalGerArqBuscarLinhas: function () {
        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar = null
        this.botaoExcluir = null
        this.botaoReativar = null
        
        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' }, { f: 'produto_acabado', o: '=', v: 's' } ] }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 2,    chave: 'codigo',        nome: 'Cód.'                        },
          { mPer: 2,    chave: 'nome',          nome: 'Nome'                        },
          { mPer: 1,    chave: 'id_uni',        nome: 'Unidade'                     },
          { mPer: 1,    chave: '_valor_ven',    nome: 'Valor Venda'                 },
          { mPer: 1,    chave: 'validade',      nome: 'Validade'                    }
        ]

        // SETA OS CAMPOS QUE DEVE BUSCAR
        this.field = {
          id: null,
          codigo: null,
          nome: null, 
          id_uni: null,
          obs: null,
          valor_ven_novo: { a: 'valor_ven' }
        }

        // SETA OS CAMPOS VIRTUAIS QUE DEVE BUSCAR
        this.fieldVir = [ 'id_uni_desc' ]

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && this.statusGeral === '') {
          this.proBalGerArqReiniciar()
        } else {
          this.proBalGerArqSetarStatusGeral('')
        }
      },
      proBalGerArqAbrirCadastro: function (tipo, id) {
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === true) {
          // SETA OS PARAMETROS QUE SERÁ ENVIADO
          var params = { editar: false, tipo: tipo, id: id }

          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.proBalGerArqBuscarLinhas()
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      proBalGerArqSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proBalGerArqReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proBalGerArqReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      proBalGerArqSetarLinhas: function (vetor) {
        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          // FORMATA O VALOR DE VENDA
          vetor[index]._valor_ven = this.$store.state.FUN_MASK_VALOR('valorDecimalNovo', vetor[index].valor_ven)

          // CONVERTE O VALOR EXISTENTE
          if (vetor[index].obs.indexOf('validade_produto') !== -1 || vetor[index].obs.indexOf('validade') !== -1) {
            // PEGA O JSON QUE TEM SALVO NO CADASTRO DO PRODUTO
            vetor[index]._obs = JSON.parse(vetor[index].obs)

            // CONVERTE O VALOR ANTIGO
            if ([ null, undefined ].indexOf(vetor[index]._obs.validade_produto) === -1) {
              vetor[index]._obs.validade = vetor[index]._obs.validade_produto
            }

            // VERIFICA SE O VALOR JÁ FOI INICIADO
            if ([ null, undefined ].indexOf(vetor[index]._obs.validade) !== -1) {
              vetor[index]._obs.validade = '3'
            }
          } else {
            vetor[index]._obs = { validade: '3' }
          }

          // PEGA O VALOR INICIAL DO CAMPO
          var option = this.campos.validade.options.filter(item => item.id === vetor[index]._obs.validade)[0]

          // SETA O NUMERO DE DIAS QUE O PRODUTO É VALIDO
          vetor[index].validade = JSON.parse(JSON.stringify(option))

          // SETA A VALIDADE INICIAL
          vetor[index].validadeIni = JSON.parse(JSON.stringify(option))
        }

        // SETA OS VALORES RECEBIDOS
        this.linhas = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proBalGerArqOnChangeValue: function (value, indexL, indexC) {
        // SETA O VALOR RECEBIDO
        this.$set(this.linhas[indexL], indexC, value)

        // LIMPA A CHAVE DE MESSAGEM DO CAMPO
        this.$set(this.linhas[indexL], (indexC + '_mensagem'), '')

        // VERIFICA SE DEVE FAZER ALGUMA AÇÃO
        switch (indexC) {
          case 'validade':
            this.proBalGerArqAtualizarCadastroProduto(indexL)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proBalGerArqAtualizarCadastroProduto: function (indexL) {
        if (JSON.stringify(this.linhas[indexL].validade) !== JSON.stringify(this.linhas[indexL].validadeIni)) {
          // CRIAR O FORMULARIO QUE SERÁ ENVIADO PARA API
          var formData = { j_id: JSON.stringify([ this.linhas[indexL].id ]) }
  
          // SETA O ID QUE SERÁ ALTERADO
          formData.obs = ([ '', null, undefined ].indexOf(this.linhas[indexL].obs) !== -1 ? {} : (this.linhas[indexL].obs.substring(0, 1) === '{' ? JSON.parse(this.linhas[indexL].obs) : {}))
  
          // REMOVE A CHAVE ANTIGA DO CADASTRO DO PRODUTO
          if ([ null, undefined ].indexOf(formData.obs.validade_produto) === -1) {
            delete formData.obs.validade_produto
          }
  
          // SETA A VALIDADE DO PRODUTO
          formData.obs.validade = this.linhas[indexL].validade

          // PEGA O VALOR SELECIONADO
          if (typeof formData.obs.validade !== 'string') {
            formData.obs.validade = formData.obs.validade.id
          }

          // CONVERTE O VALOR EM JSON STRING
          formData.obs = JSON.stringify(formData.obs)
          
          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/produto', 'PUT', formData, (retorno) => {
            // SETA O RETORNO RECEBIDO
            this.$store.state.TRATAR_RET_LOT_API(retorno)

            // ATUALIZA O VALOR INICIAL DO CAMPO
            this.linhas[indexL].validadeIni = JSON.parse(JSON.stringify(this.linhas[indexL].validade))

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.proBalGerArqSetarStatusGeral, this.proBalGerArqSetarStatusGeral)
        }
      },
      proBalGerArqFormatarNumero: function (valor, qtde) {
        // ADICIONA ESPAÇO AO NOME DO PRODUTO
        while(valor.toString().length < qtde) {
          valor = '0'.toString() + valor.toString()
        }

        // VERIFICA SE DEU ERRO
        if (valor.length === qtde) {
          return valor
        }
      },
      proBalGerArqFormatarString: function (valor, qtde) {
        // CONVERTE O VALOR RECEBIDO EM STRING
        valor = valor.toString()

        // ADICIONA ESPAÇO AO NOME DO PRODUTO
        while(valor.length < qtde) {
          valor = valor + ' '
        }

        // PEGA PARTE DO NOME APENAS
        if (valor.length > qtde) {
          valor = valor.substring(0, qtde)
        }

         return valor
      },
      proBalGerArqRemoverCaracteresEspeciais: function (valor) {
        // MONTA O MAPA DO REGX
        var regxMap = {
          a: /[\xE0-\xE6]/g,
          A: /[\xC0-\xC6]/g,
          e: /[\xE8-\xEB]/g,
          E: /[\xC8-\xCB]/g,
          i: /[\xEC-\xEF]/g,
          I: /[\xCC-\xCF]/g,
          o: /[\xF2-\xF6]/g,
          O: /[\xD2-\xD6]/g,
          u: /[\xF9-\xFC]/g,
          U: /[\xD9-\xDC]/g,
          c: /\xE7/g,
          C: /\xC7/g,
          n: /\xF1/g,
          N: /\xD1/g
        }

        for ( var indexL in regxMap ) {
          // PEGA A EXPRESSÃO QUE DEVE REALIZAR
          var regex = regxMap[indexL]

          // REMOVE OS CARACTERES INVALIDOS
          valor = valor.replace(regex, indexL)
        }

        // REMOVE OS ACENTOS E CARACTERES ESPECIAIS
        valor = valor.replace(/[^A-Za-z0-9]/g, ' ')

        // RETORNA A STRING SOLICITADA
        return valor.toUpperCase()
      },
      proBalGerArqOnGerarArquivo: function () {
        // INICIA O VETOR COM AS VARIAVEIS
        var linhas = []

        // INICIA A LINHA DO PRODUTO
        var linha = ''

        // LINK DO LAYOUT
        // http://docs.autocom3.com.br/wp-content/uploads/2018/07/1-2.png

        for (var key in this.linhas) {
          // =========================> INICIA A LINHA
          linha = ''

          // =========================> ADICIONA O CODIGO DO DEPARTAMENTO
          linha += this.proBalGerArqFormatarNumero(this.campos.dep.value, 2)

          // =========================> INFORMA SE É PESO OU UNIDADE
          // [0] => Venda por peso
          // [1] => Venda por unidade
          // [2] => EAN-13 por peso
          // [3] => Venda por peso glaciado
          // [4] => Venda por peso drenado
          // [5] => EAN-13 por unidade
          switch (this.linhas[key].id_uni) {
            case 'KG':
              linha += '0'
              break

            default:
              linha += '1'
              break
          }
          
          // =========================> SETA O CODIGO DO ITEM
          linha += this.proBalGerArqFormatarNumero(this.linhas[key].id, 6)

          // =========================> SETA O VALOR DO PRODUTO
          linha += this.proBalGerArqFormatarNumero((Number(Number(this.linhas[key].valor_ven).toFixed(2)) * 100).toFixed(0), 6)

          // =========================> SETA A QUANTIDADE DIA DE VALIDADE DO PRODUTOS
          var validade = typeof this.linhas[key].validade === 'string' ? this.linhas[key].validade : this.linhas[key].validade.id
          linha += this.proBalGerArqFormatarNumero(validade, 3)

          // =========================> SETA O NOME DO PRODUTO
          linha += this.proBalGerArqFormatarString(this.linhas[key].nome, 50)

          // =========================> SETA O CODIGO DA EXTRA DO ITEM
          linha += this.proBalGerArqFormatarNumero('0', 6)

          // =========================> SETA O CODIGO DA IMAGEM DO ITEM
          linha += this.proBalGerArqFormatarNumero('0', 4)

          // =========================> SETA O CODIGO DA INFORMAÇÃO NUTICIONAL
          linha += this.proBalGerArqFormatarNumero('0', 6)

          // =========================> SETA SE DEVE IMPRIMIR A DATA DE VALIDADE OU NÃO
          // [0] => Não Imprime Data de Validade
          // [1] => Imprime Data de Validade
          switch (validade) {
            case '':
              linha += '0' // SEM DATA DE VALIDADE
              break

            default:
              linha += '1'
              break
          }

          // =========================> SETA SE DEVE IMPRIMIR A DATA DE EMBALAGEM DO PRODUTO
          // [0] => Não Imprime Data de Embalagem
          // [1] => Imprime Data de Embalagem
          switch (this.linhas[key].id_uni) {
            case 'KG':
              linha += '1'
              break

            default:
              linha += '0'
              break
          }

          // // =========================> SETA O CODIGO DO FORNECEDOR
          // linha += this.proBalGerArqFormatarNumero('0', 4)

          // =========================> FINALIZA ARQUIVO
          linha += '0000000000000000000000000001000000000000000000000000000000000000000000|01|                                                                      0000000000000000000000000||0||'

          // REMOVE OS CARACTERES ESPECIAIS
          linha = this.proBalGerArqRemoverCaracteresEspeciais(linha)

          // ADICIONA A LINHA NO VETOR
          linhas.push(linha)
        }

        // // COLOCA UMA QUEBRA DE LINHA ENTRE AS LINHAS
        // linhas = linhas.join('<br/>')

        // CRIA O BOTÃO PARA FAZER O DOWNLOAD
        var element = document.createElement('a')

        // SETA O CONTEUDO DO ARQUIVO
        element.setAttribute('href', 'data:text/plaincharset=utf-8,' + encodeURIComponent(linhas.join('\n')))

        // SETA O NOME DO ARQUIVO
        element.setAttribute('download', 'ITENSMGV.TXT')

        // DEIXA O ARQUIVO BOTÃO OCULTO
        element.style.display = 'none'

        // ADICIONA O BOTÃO NA TELA
        document.body.appendChild(element)

        // REALIZA O CLICK PARA BAIXAR O ARQUIVO
        element.click()

        // REMOVE O BOTÃO, PARA NÃO FICAR LIXO PERDIDO
        document.body.removeChild(element)

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
    }
  }
</script>
